import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { BLACK, BG_GRAY, WHITE } from '../../../styles/variables.style';

const Item = styled.button`
  background-color: ${BG_GRAY.COMMON_1};
  border: none;
  color: ${BLACK};
  cursor: pointer;
  font-size: 14px;
  height: 45px;
  outline: none;
  padding: 0 30px;
  text-align: left;
  text-transform: uppercase;
  width: 100%;

  span {
    vertical-align: middle;
    letter-spacing: 1px;
  }

  > span:first-child {
    background-color: ${({ selected }) => (selected ? BLACK : WHITE)};
  }
`;

const Checkmark = styled.span`
  display: inline-block;
  position: relative;
  width: 25px;
  height: 25px;
  border: 1px solid ${BLACK};
  margin-right: 12px;
  border-radius: 50%;

  ::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%) rotate(-45deg);
    border-bottom: 1px solid ${WHITE};
    border-left: 1px solid ${WHITE};
    width: 8px;
    height: 4px;
  }
`;

class FilterItem extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired,
  };

  handleClick = () => {
    const { label, onClick, selected } = this.props;
    onClick(label, selected);
  };

  render = () => {
    const { label, selected } = this.props;

    return (
      <Item onClick={this.handleClick} selected={selected}>
        <Checkmark />
        <span>{label}</span>
      </Item>
    );
  };
}

export default FilterItem;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/MobileDropdown/FilterItem.js